import {
  IUseChatHandlers,
  ThirdPartyChatProvider,
  UseInitChatProviderType,
} from '@core/chat/interfaces';
import { env } from 'env';
import useInitStreamChatProvider from '@core/chat/StreamChat/hooks';

const thirdPartyProvider =
  env.REACT_APP_FEATURE_THIRD_PARTY_CHAT_PROVIDER ||
  ThirdPartyChatProvider.StreamChat;

let useInitChatProvider: UseInitChatProviderType;
if (thirdPartyProvider === ThirdPartyChatProvider.StreamChat) {
  useInitChatProvider = useInitStreamChatProvider;
} else {
  throw new Error(`Unknown library: ${thirdPartyProvider}`);
}

const useChatHandlers = ({
  currentEvent,
  streamChatToken,
  isStreamChatUnavailable,
}: IUseChatHandlers) => {
  useInitChatProvider({
    currentEvent,
    streamChatToken,
    isStreamChatUnavailable,
  });
};

export default useChatHandlers;
